import { Component } from '@angular/core';
import { PairingChallengeContainerComponent } from '../../../../features/devices/components/pairing-challenge/pairing-challenge.container';

@Component({
  selector: 'era-pair-confirm-page',
  templateUrl: './confirm.page.html',
  styleUrls: ['./confirm.page.scss'],
  imports: [PairingChallengeContainerComponent],
})
export class PairConfirmPage {}
